import { JetView } from "webix-jet";

export default class EditorView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;

		const tabbar = {
			view: "tabbar",
			localId: "tabbar",
			tabMinWidth: 80,
			css: "webix_um_editor_tabbar",
			height: webix.skin.$active.barHeight - 2,
			type: "bottom",
			borderless: true,
			options: [
				{ id: "roles.form", value: _("General") },
				{ id: "roles.rules", value: _("Rules") },
				{ id: "roles.members", value: _("Members") },
			],
			on: {
				onChange: v => this.SetMode(v),
			},
		};
		const toolbar = {
			view: "toolbar",
			padding: {
				left: 2,
				right: 0,
				top: 0,
				bottom: 0,
			},
			cols: [
				{
					view: "icon",
					icon: "umi-back",
					click: () =>
						this.app.callEvent("details.back:click", [
							"roles",
							this.getParam("id", true),
						]),
				},
				tabbar,
			],
		};

		return {
			rows: [toolbar, { $subview: true }],
		};
	}

	init() {
		if (this.getUrl().length < 2) this.show("./roles.form");
		else this.$$("tabbar").setValue(this.getUrl()[1].page);
	}

	SetMode(v) {
		this.show(v);
	}
}
